define('glu/grid/filter/badges/filterBadgesRow',['require','./filterBadges','./filterBadge'],function(require) {
    'use strict';

    var FilterBadges = require('./filterBadges'),
        BadgeItemView = require('./filterBadge');

    return FilterBadges.extend({
        itemView: BadgeItemView,

        tagName: 'tr',

        initialize: function() {
            FilterBadges.prototype.initialize.apply(this, arguments);

            this.collection = this.columns;
            this.listenTo(this.filters, 'change reset add remove refresh', this.setColumnsConditionAndRender);
        },

        setColumnsConditionAndRender: function() {
            this.setColumnsCondition();
            this.render();
        },

        hasFilters: function() {
            return !this.filters.isEmpty();
        },

        onRender: function() {
            this.toggleBadges();
        },

        toggleBadges: function() {
            this.$el.toggleClass('hidden', !this.hasFilters());
        }
    });
});

